import React, { useState, useEffect } from "react";
import "./VendorListingPage.css"; // Import the CSS file
import { useLocation, useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import ActiveVendors from "./ActiveVendors"; // Import ActiveVendors component
import { ShowAllCategories } from "../../../context/Slice/VendorManagementSlice";
import { useDispatch, useSelector } from "react-redux";

const BackEnd_URL = process.env.REACT_APP_BASE_URL;

const VendorListingPage = () => {
  const [showLoginPopup, setShowLoginPopup] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [filteredVendorsData, setFilteredVendorsData] = useState([]);
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const params = new URLSearchParams(location.search);
  const vendors = location.state?.vendors || {};

  const categoryName =
    location.state?.categoryName || params.get("category") || "";
  const locationName =
    location.state?.locationName || params.get("ServiceLocations") || "";

  console.log("Category Name:", categoryName);
  console.log("Location Name:", locationName);

  const testcategorie = useSelector((state) => state.VendorManagementR.AllCat);

  console.log(testcategorie);

  useEffect(() => {
    // Dispatch the action
    dispatch(ShowAllCategories())
      .unwrap()
      .then((result) => {
        console.log("Categories fetched successfully:", result);
      })
      .catch((error) => {
        console.error("Error fetching categories:", error);
      });
  }, [dispatch]);

  useEffect(() => {
    if (vendors.data?.allVendorService?.length > 0) {
      console.log("Using provided vendor data:", vendors.data.allVendorService);
      setFilteredVendorsData(vendors.data.allVendorService);
    } else {
      console.log("Fetching vendors from API...");
      setLoading(true);
      setError("");

      // Simulate API Call (Replace with actual fetch API)
      setTimeout(() => {
        setFilteredVendorsData([]); // Simulating no vendors found
        setLoading(false);
      }, 1000);
    }
  }, []);

  const parseImageUrl = (imageData) => {
    try {
      console.log("Parsing Banner Image:", imageData);
      const parsedData = JSON.parse(imageData); // Parse the stringified JSON
      const imagePath = parsedData[0]?.path.replace(/\\/g, "/"); // Ensure the path is properly formatted

      // You need to ensure the path is accessible from the frontend
      const imageUrl = `${BackEnd_URL}/BannerUploads/${imagePath
        .split("/")
        .pop()}`; // Assuming the server serves images from '/BannerUploads'

      console.log("Parsed Image URL:", imageUrl);
      return imageUrl || "assets/dummyProfile.jpg"; // Fallback to a default image
    } catch (err) {
      console.warn("Failed to parse image data. Returning default image.", err);
      return "assets/dummyProfile.jpg"; // Fallback to a default image
    }
  };
  const handleViewDetails = (vendor) => {
    // Get the token from local storage
    const token = localStorage.getItem("token");

    if (token) {
      try {
        // Decode the JWT token
        const decodedToken = jwtDecode(token);

        // Extract the role from the decoded token
        const role = decodedToken.role;

        // Save the role to localStorage
        localStorage.setItem("role", role);
        console.log("Role extracted from token:", role);

        if (vendor.ServiceCategory_ID) {
          localStorage.setItem("ServiceCategory_ID", vendor.ServiceCategory_ID);
          console.log("Stored ServiceCategory_ID:", vendor.ServiceCategory_ID);
        }

        // Check if the role is valid
        const allowedRoles = ["USER", "ADMIN", "VENDOR", "CO-ORDINATOR"];
        if (allowedRoles.includes(role)) {
          navigate(`/vendor-details/${vendor.Vendor_ID}`);
        } else {
          setShowLoginPopup(true); // Show login popup if role is not valid
        }
      } catch (error) {
        console.error("Error decoding token:", error);
        setShowLoginPopup(true); // Show login popup if token is invalid
      }
    } else {
      setShowLoginPopup(true); // Show login popup if no token
    }
  };
  const handleLoginRedirect = () => {
    setShowLoginPopup(false); // Close the popup
    navigate("/login"); // Redirect to the login page
  };

  const handleCategoryChange = (e) => {
    const selectedCategory = e.target.value;

    if (selectedCategory === "") {
      // Show all vendors when "Select Category" is chosen
      setFilteredVendorsData(vendors.data.allVendorService);
    } else {
      // Filter vendors based on the selected category
      const filtered = vendors.data.allVendorService.filter(
        (vendor) => vendor.Category.CategorieName === selectedCategory
      );
      setFilteredVendorsData(filtered);
    }
  };

  const clearFilters = () => {
    setFilteredVendorsData(vendors.data.allVendorService);
    document
      .querySelectorAll("select")
      .forEach((select) => (select.value = ""));
  };

  return (
    <div>
      <section id="vendor-listing">
        <div className="vendor-listing-page__scrollable">
          {/* Navbar & Filters */}
          <div className="row navbarcontainer">
            <div
              className="filter-section align-items-center d-flex flex-column"
              style={{ justifyContent: "center" }}
            >
              <div className="text-sm mb-2" style={{ paddingTop: "10px" }}>
                <strong className="text-xs" style={{ fontSize: "12px" }}>
                  Categories
                </strong>
              </div>
              <div className="filter-options flex flex-col space-y-4">
                <select
                  className="w-[151px] rounded-[5px] border border-[#ddd] text-[10px] box-border"
                  style={{
                    padding: "10px",
                    border: "2px solid #ced4da",
                    borderRadius: "0.35rem",
                  }}
                  onChange={handleCategoryChange}
                >
                  <option value="">Select Category</option>
                  {testcategorie &&
                    testcategorie.map((cate, index) => (
                      <option key={index} value={cate.CategorieName}>
                        {cate.CategorieName}
                      </option>
                    ))}
                </select>

                {/* Clear Button */}
                <div className="clear-btn-container mt-2">
                  <button
                    style={{
                      padding: "0.5rem 1rem",
                      backgroundColor: "transparent",
                      border: "2px solid #f87171",
                      color: "#f87171",
                      borderRadius: "0.5rem",
                      transition: "background-color 0.3s ease",
                    }}
                    onClick={clearFilters}
                    onMouseOver={(e) =>
                      (e.target.style.backgroundColor = "#fef2f2")
                    }
                    onMouseOut={(e) =>
                      (e.target.style.backgroundColor = "transparent")
                    }
                  >
                    Clear Filters
                  </button>
                </div>
              </div>
            </div>
          </div>

          {/* Vendor Listing */}
          {filteredVendorsData.length > 0 ? (
            <div className="row ml-2" style={{ marginInline: "20px" }}>
              <h2 className="mb-[1px]" style={{ marginTop: "16rem" }}>
                {categoryName || locationName || "All Locations"} Vendors
              </h2>
              <div className="row row-card-container">
                <div className="col-md-3 mb-4 cardcontainer">
                  {filteredVendorsData
                    .filter((vendor) => vendor.status === "approved")
                    .map((vendor, index) => {
                      const imageUrl = vendor.BannerImage
                        ? parseImageUrl(vendor.BannerImage)
                        : "/assets/dummyProfile.jpg";

                      return (
                        <div className="card vendor-card" key={index}>
                          <img
                            src={imageUrl}
                            className="card-img-top vendor-card-img"
                            alt={vendor.ServiceName}
                          />
                          <div className="vendor-card-body">
                            <h5 className="vendor-name">
                              {vendor.Vendor?.firstName || "Unknown"}
                            </h5>
                            <div
                              className="vendor-card-info"
                              style={{
                                display: "flex",
                                flexDirection: "column",
                              }}
                            >
                              <span className="vendor-location">
                                <strong>Service Locations:</strong>{" "}
                                {(() => {
                                  try {
                                    return vendor && vendor.ServiceLocations
                                      ? Array.isArray(
                                          JSON.parse(vendor.ServiceLocations)
                                        )
                                        ? JSON.parse(
                                            vendor.ServiceLocations
                                          ).join(", ")
                                        : "Unknown Location"
                                      : "Unknown Location";
                                  } catch (error) {
                                    return "Unknown Location";
                                  }
                                })()}
                              </span>

                              <span className="vendor-budget">
                                <strong>Budget:</strong>{" "}
                                {vendor.ServiceName === "VENUE" ||
                                vendor.ServiceName === "WEDDING CATERERS"
                                  ? JSON.parse(vendor.DynamicData || "{}")[
                                      "BudgetSlab"
                                    ] || "N/A"
                                  : vendor.TotalBudget || "N/A"}
                              </span>

                              <span className="vendor-category">
                                <strong>Category:</strong>{" "}
                                {vendor.Category?.CategorieName || "Unknown"}
                              </span>
                            </div>
                            <button
                              className="btn btn-primary vendor-btn"
                              onClick={() => handleViewDetails(vendor)}
                            >
                              View Details
                            </button>
                          </div>
                        </div>
                      );
                    })}
                </div>
              </div>
            </div>
          ) : (
            <ActiveVendors
              cateName={categoryName}
              locationName={locationName}
            />
          )}

          {/* Login Popup */}
          {showLoginPopup && (
            <div className="popup-overlay">
              <div className="popup-content">
                <p>To know the vendor details, please log in first.</p>
                <button
                  className="btn btn-primary"
                  onClick={handleLoginRedirect}
                >
                  Login
                </button>
              </div>
            </div>
          )}
        </div>
      </section>
    </div>
  );
};

export default VendorListingPage;
